const translations = {
  pt: {
    resetPasswordTitle: 'Redefinir Senha',
    newPassword: 'Nova Senha',
    confirmPassword: 'Confirmar Nova Senha',
    resetPasswordButton: 'Redefinir Senha',
    loading: 'Carregando...',
    successPasswordReset: 'Senha redefinida com sucesso! Redirecionando para login...',
    errorInvalidToken: 'Token inválido ou expirado.',
    errorTokenExpired: 'Token expirado. Solicite uma nova redefinição de senha.',
    errorPasswordMismatch: 'As senhas não coincidem.',
    errorPasswordTooShort: 'A senha deve ter pelo menos 6 caracteres.',
    errorServer: 'Erro interno do servidor. Tente novamente mais tarde.'
  },
  en: {
    resetPasswordTitle: 'Reset Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    resetPasswordButton: 'Reset Password',
    loading: 'Loading...',
    successPasswordReset: 'Password reset successfully! Redirecting to login...',
    errorInvalidToken: 'Invalid or expired token.',
    errorTokenExpired: 'Token expired. Request a new password reset.',
    errorPasswordMismatch: 'Passwords do not match.',
    errorPasswordTooShort: 'Password must be at least 6 characters long.',
    errorServer: 'Internal server error. Please try again later.'
  }
};

export default translations;